import { useRoutes } from "react-router-dom";
import routes from "./routes";

const Router = () => {
  const elements = useRoutes(routes);
  return elements;
};

export default Router;
